import * as React from 'react';

import { AuthModal } from '../auth-modal';
import { BonusModal } from '../bonus-modal';
import { CoinRaceRulesModal } from '../coin-race-rules-modal';
import { ConfirmModal } from '../confirm-modal';
import { JackpotInfoModal } from '../jackpot-info-modal';
import { JoinRaceConfirmModal } from '../join-race-confirm-modal';
import { OfferModal } from '../offer-modal';
import { OfferRulesModal } from '../offer-rules-modal';
import { PromotionBuyTicketModal } from '../promotion-buy-ticket-modal';
import { PromotionParticipantsModal } from '../promotion-participants-modal';
import { PromotionWinnerListModal } from '../promotion-winner-list-modal';
import { PromotionWinnerModal } from '../promotion-winner-modal';
import { QuestDetailsModal } from '../quest-details-modal';
import { RegisterModal } from '../register-modal';
import { ShopItemModal } from '../shop-item-modal';
import { TournamentModal } from '../tournament-modal';
import { TradeLinkHelpModal } from '../trade-link-help-modal';

export const ModalContainer = () => {
	return (
		<>
			<AuthModal />
			<RegisterModal />
			<OfferRulesModal />
			<OfferModal />
			<BonusModal />
			<TradeLinkHelpModal />
			<ConfirmModal />
			<PromotionParticipantsModal />
			<PromotionWinnerModal />
			<PromotionBuyTicketModal />
			<QuestDetailsModal />
			<TournamentModal />
			<PromotionWinnerListModal />
			<ShopItemModal />
			<JackpotInfoModal />
			<JoinRaceConfirmModal />
			<CoinRaceRulesModal />
			{/* Add other modals here */}
		</>
	);
};
